// Restaurant price ranges database
export const priceRanges = {
  '103 Coffee': 'RM20-40',
  "A'Decade": 'RM20-40',
  'Armoury Steakhouse': 'RM20-80+',
  'Ba Shu Jia Yan': 'RM40-60',
  'Beutea': 'RM1-20',
  'Black Canyon': 'RM20-40',
  'Bread History': 'RM1-20',
  'Chagee': 'RM1-20',
  'ChaPanda': 'RM1-20',
  'Chatramue': 'RM1-20',
  "Christine's Bakery Cafe": 'RM20-40',
  'CHUCHAT': 'RM1-20',
  'Coffee Bean': 'RM20-40',
  'Yakiniku Smile': 'RM40-60',
  'Count (Flower Drum)': 'RM20-60',
  'CU Mart': 'RM1-20',
  'DOZO': 'RM20-60',
  'Empire Sushi': 'RM1-20',
  'Far Coffee': 'RM1-40',
  'Fong Woh Tong': 'RM1-20',
  'Gokoku Japanese Bakery': 'RM1-20',
  'Gong Cha': 'RM1-20',
  'Gong Luck Cafe': 'RM20-40',
  'Han Bun Sik': 'RM20-40',
  'Happy Potato': 'RM1-20',
  'Hock Kee Kopitiam': 'RM1-40',
  'I LIKE & Yogurt In A Can': 'RM1-20',
  "I'm Bagel": 'RM1-20',
  'JP & CO': 'RM20-40',
  'Kanteen': 'RM20-40',
  'Kedai Kopi Malaya': 'RM1-20',
  'Kenangan Coffee': 'RM1-20',
  'Kha Coffee Roaster': 'RM20-40',
  'LLAO LLAO': 'RM1-20',
  'Luckin': 'RM1-20',
  'Manjoe': 'RM20-40',
  'Missy Sushi': 'RM40-60',
  'Mr. Wu': 'RM20-40',
  'Nasi Lemak Shop': 'RM20-40',
  'Nine Dragon Char Chan Teng (Kowloon Cafe)': 'RM20-40',
  'Nippon Sushi': 'RM20-40',
  'Odon Beyond': 'RM20-40',
  'One Dish One Taste': 'RM40-80+',
  'Pak Curry': 'RM1-20',
  'Ramen Mob': 'RM20-40',
  'Richeese Factory': 'RM20-40',
  'Salad Atelier': 'RM20-40',
  'Shabuyaki by Nippon Sushi': 'RM40-60',
  "Stuff'D": 'RM1-20',
  'Subway': 'RM1-20',
  'Super Matcha': 'RM1-20',
  'Sweetie': 'RM1-20',
  'Tang Gui Fei Tanghulu': 'RM1-20',
  'Tealive Plus': 'RM1-20',
  'The Chicken Rice Shop': 'RM20-40',
  'The Public House': 'RM40-60',
  'The Walking Hotpot Signature': 'RM20-40',
  'Yama by Hojichaya': 'RM1-20',
  'Yellow Bento': 'RM1-20',
  'Yogurt Planet': 'RM1-20',
  'Yonny': 'RM20-40',
  'Zok Noodle House': 'RM20-40',
  'Zus Coffee': 'RM1-20',
};

export const getPriceRange = (restaurantName) => {
  return priceRanges[restaurantName] || 'N/A';
};

function parseRange(range) {
  const s = String(range || '');
  const plus = s.includes('+');
  const m = s.match(/RM\s*(\d+)\s*-\s*(\d+)/i);
  if (!m) return { low: null, high: null, plus };
  const low = Number(m[1]);
  const high = Number(m[2]);
  return {
    low: Number.isFinite(low) ? low : null,
    high: Number.isFinite(high) ? high : null,
    plus,
  };
}

// Budget tiers for filtering (can be multiple) with strict boundaries:
// - "Below RM20" matches only if low < 20 (RM1-40 ✅, RM20-40 ❌)
// - "RM20 - RM40" matches only if the range has values strictly between 20 and 40 (RM1-20 ❌, RM20-40 ✅, RM40-60 ❌)
// - "Above RM40" matches only if range has values > 40 (RM40-60 ✅, RM20-40 ❌)
export function budgetTiersForRestaurant(restaurantName) {
  const range = getPriceRange(restaurantName);
  if (!range || range === 'N/A') return [];
  const { low, high, plus } = parseRange(range);
  if (low === null) return [];
  const upper = plus ? Number.POSITIVE_INFINITY : high;
  if (!Number.isFinite(upper)) return [];

  const tiers = [];
  if (low < 20) tiers.push('Below RM20');
  if (upper > 20 && low < 40) tiers.push('RM20 - RM40');
  if (upper > 40) tiers.push('Above RM40');
  return tiers;
}
